const headerStyle = theme => ({
    head: {
        color: '#595959',
        fontWeight: 'bold',
        backgroundColor: '#e2e2e2',
        fontSize: '13px',
        padding:'4px 8px 4px 8px !important',
    },
    headAction: {
        color: '#595959',
        fontWeight: 'bold',
        backgroundColor: '#e2e2e2',
        fontSize: '13px',
        padding:'4px 8px 4px 8px !important',
        textAlign: 'center !important',
    },
    headerHeight: {
        height: '28px',
      }, 
});

export default headerStyle;